import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { zendeskService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetZendeskLinkMutation = type => {
	const dispatch = useDispatch();

	return useMutation(
		(id): any => {
			return zendeskService.getZendeskLink(type, id);
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useGetZendeskLinkMutation;
